// src/helpers/factories/settings/prepStationsFactory.ts
var prepStationsOptionModalFactory = (prepStations) => Object.entries(prepStations).map(([prepStationId, prepStation]) => ({
  label: prepStation.name,
  value: Number(prepStationId)
}));

export { prepStationsOptionModalFactory };
